<template>
    <v-flex xs12>
        <h1 style="font-size: 32pt; color: #DB1918;"><slot></slot></h1>
    </v-flex>
</template>

<script>
    export default {
        name: 'Title',
        components: { },
        data() {
            return {
            }
        }
    }
</script>

<style>
</style>
